import { render, staticRenderFns } from "./comRule.vue?vue&type=template&id=3b2298ea&scoped=true&"
import script from "./comRule.vue?vue&type=script&lang=js&"
export * from "./comRule.vue?vue&type=script&lang=js&"
import style0 from "./comRule.vue?vue&type=style&index=0&id=3b2298ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2298ea",
  null
  
)

export default component.exports